import React, {FC, useState} from "react";
import {useTranslation} from "react-i18next";
import PaymentsList from "./PaymentsList";
import './PystackPayments.css';
interface BPProps {
    initPaystack?: () => void;
    makeMarketVisible?: () => void;
    setHidePaystack: () => void;
    isAuth: boolean;
    styles: any
    conditions?: any
    placeholder: string,
    handleChangeNumber: (number: string) => void,
}
const PystackPayments:FC <BPProps> = ({initPaystack, styles, makeMarketVisible,setHidePaystack, handleChangeNumber, placeholder,isAuth, conditions}) => {
    const { t } = useTranslation();

    return (
        <>
            {
                isAuth ?
                    <div className='paystack-wrapper card-rounded position-relative card-px rounded mt-3'
                         style={{border: `1px solid ${styles.colors.fontColor}`}}>
                        <h2
                            className='text-center rounded title p-1 m-2'
                            style={{
                                color: styles.colors.fontTitleColor,
                                fontSize: styles.fonts.titleFontSize,
                                backgroundColor: styles.colors.blockTitleBgColor,
                                textTransform: 'uppercase'
                            }}
                        >
                            {t('paystack.title')}
                        </h2>
                        <button
                            onClick={initPaystack}
                            style={{
                                backgroundColor: 'black',
                                color: '#f08426',
                                fontSize: styles.fonts.buttonFontSize,
                                fontFamily: styles.fonts.titleFontFamily,
                                fontWeight: 'bold',
                                textTransform: 'uppercase',
                                width: '80%',
                                maxWidth: '410px',
                                margin: '0 auto',
                                display: 'block',
                            }}
                            className='btn mt-2 mb-3 paystack-init p-3'
                        >
                            {t('paystack.clickToPay')}
                        </button>
                        <PaymentsList styles={styles} />
                    </div>
                    :
                    <div className='paystack-wrapper card-rounded position-relative card-px rounded mt-3'
                         style={{border: `1px solid ${styles.colors.fontColor}`}}>
                        <div className="card-body p-3">
                            <h2
                                className='text-center rounded title p-1 m-2'
                                style={{
                                    color: styles.colors.fontTitleColor,
                                    fontSize: styles.fonts.titleFontSize,
                                    backgroundColor: styles.colors.blockTitleBgColor,
                                    textTransform: 'uppercase'
                                }}
                            >
                                {t('paystack.title')}
                            </h2>
                            {
                                conditions && conditions !== undefined && Object.keys(conditions).length > 0 ?
                                    <button
                                        onClick={initPaystack}
                                        disabled={conditions.total_odds < conditions.minTicketOdds}
                                        style={{
                                            backgroundColor: 'black',
                                            color: '#f08426',
                                            fontSize: styles.fonts.buttonFontSize,
                                            fontFamily: styles.fonts.titleFontFamily,
                                            fontWeight: 'bold',
                                            textTransform: 'uppercase',
                                            width: '80%',
                                            maxWidth: '410px',
                                            margin: '0 auto',
                                            display: 'block',
                                        }}
                                        className='btn mt-2 paystack-init p-2'
                                    >
                                        {t('brite.playNow')}
                                    </button>
                                    :
                                    null
                            }
                            {
                                conditions && conditions.total_odds < conditions.minTicketOdds ? (
                                    <div style={{color: 'red'}}>
                                        {t('notifications.notEnoughOdds')}
                                    </div>
                                ) : null
                            }
                            {
                                makeMarketVisible ?
                                    <p
                                        className="mt-3 text-center fs-6"
                                        onClick={makeMarketVisible}
                                    >
                                        {t('quickbet.priceBlock.changeBet')}
                                    </p>
                                    : null
                            }
                            <div className="card-body">
                                <div
                                    style={{
                                        color: styles.colors.fontColor,
                                        textAlign: 'left',
                                    }}
                                >
                                    Enter mobile number
                                </div>
                                <div className="input-group">
                                    <input
                                        style={{
                                            "--placeholder-color": 'rgb(240, 132, 38)',
                                            backgroundColor: styles.colors.fieldsBgColor,
                                            color: styles.colors.fieldsFontColor,
                                            borderRadius: '5px',
                                            display: 'block'
                                        } as React.CSSProperties}
                                        className="form-control custom-placeholder"
                                        type="tel"
                                        id="tel"
                                        required
                                        maxLength={12}
                                        minLength={9}
                                        name="msisdn"
                                        placeholder={placeholder}
                                        onChange={(e) => handleChangeNumber(e.target.value)}
                                    />
                                </div>
                                <button
                                    onClick={initPaystack}
                                    style={{
                                        backgroundColor: 'black',
                                        color: '#f08426',
                                        fontSize: styles.fonts.buttonFontSize,
                                        fontFamily: styles.fonts.titleFontFamily,
                                        fontWeight: 'bold',
                                        textTransform: 'uppercase',
                                        width: '80%',
                                        maxWidth: '410px',
                                        margin: '0 auto',
                                        display: 'block',
                                    }}
                                    className='btn mt-3 paystack-init p-3'
                                >
                                    {t('paystack.clickToPay')}
                                </button>
                                <div className="mt-3">
                                    <PaymentsList styles={styles} />
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </>
    )
};

export default PystackPayments;